export enum ActionStatus
{
    Active,
    Activated,
    Inactive,
    Skipped,
}